import { Controller } from '@hotwired/stimulus'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
// No style import: CSS goes through Dart Sass, not webpack - app/assets/stylesheets/default/_info_requests.scss.

// data-controller belongs on a wrapper, never the input: intlTelInput() reparents the input into
// its own .iti markup, which Stimulus reads as disconnect-then-reconnect and loops forever.
export default class extends Controller {
  static targets = ['input', 'countryCode']

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      strictMode: true,
      initialCountry: this.inputTarget.dataset.intlTelInputInitialCountry || 'auto',
      geoIpLookup: (callback) => callback(this.inputTarget.dataset.intlTelInputInitialCountry || 'us')
    })

    // The dial code posts as its own field; phone stays exactly as typed.
    this.inputTarget.form?.addEventListener('submit', () => {
      if (this.hasCountryCodeTarget) {
        this.countryCodeTarget.value = this.iti.getSelectedCountryData().dialCode
      }
    })
  }

  disconnect() {
    this.iti?.destroy()
  }
}
